import type { ScheduleConfigurationPrePublishCheckDto } from 'services/api';

type ChecksErrorsByCodeMapper = Record<
  string,
  Omit<ScheduleConfigurationPrePublishCheckDto, 'code'>[]
>;

export const mapChecksErrorsByCode = (
  errors: ScheduleConfigurationPrePublishCheckDto[],
): ChecksErrorsByCodeMapper => {
  const result: ChecksErrorsByCodeMapper = {};

  errors.forEach((error) => {
    const { code, ...otherErrorProps } = error;

    if (!Object.hasOwn(result, code)) {
      result[code] = [];
    }
    result[code].push({ ...otherErrorProps });
  });
  return result;
};
